"use client";

/**
 * Deprecated — superseded by PostHog exception autocapture.
 *
 * This component used to wire `window.onerror` / `window.onunhandledrejection`
 * by hand and send a `posthog.capture("$exception", { message, stack, source })`
 * event. That payload had no `$exception_list`, so PostHog's Error Tracking
 * never grouped it into an Issue — Error Tracking showed zero issues despite
 * exceptions firing.
 *
 * Exception capture now lives in components/analytics/posthog-provider.tsx via
 * `posthog.startExceptionAutocapture()`, which captures the same surface
 * (unhandled errors, unhandled rejections, console errors) with the correct
 * `$exception_list` shape. React render errors — which never reach
 * window.onerror — are captured by app/error.tsx via `posthog.captureException`.
 *
 * The component is kept as a null render so existing mount points
 * (components/app-shell/deferred-widgets.tsx → AppErrorCapture) and tests keep
 * working without a second edit; it intentionally does nothing now to avoid
 * double-capturing every exception.
 */
export function ErrorCapture() {
  return null;
}
